// UA markery známych in-app prehliadačov (FB/IG reklamy, sociálne appky).
// Zdroj: oficiálna FB dokumentácia + bežné UA reťazce jednotlivých platforiem.
const IN_APP_BROWSER_MARKERS = [
  // Facebook / Meta
  'FBAN',
  'FBAV',
  'FB_IAB',
  'FBIOS',
  // Instagram
  'Instagram',
  'IGID',
  // YouTube
  'YouTube',
  // TikTok
  'TikTok',
  'musical_ly',
  'BytedanceWebview',
  'trill_',
  // LinkedIn
  'LinkedInApp',
] as const

const ANDROID_WEBVIEW_PATTERN = /;\s*wv/i
const IOS_IN_APP_BROWSER_PATTERN =
  /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i

/**
 * Deteguje, či beží stránka v in-app WebView (FB, IG, YouTube, TikTok, LinkedIn
 * alebo generický Android/iOS embedded prehliadač). Také prostredie často blokuje
 * popup okná — napr. pri Veriff overení identity.
 */
export const isSocialNetworkInAppWebView = (): boolean => {
  if (typeof navigator === 'undefined') return false

  const userAgent = navigator.userAgent

  if (IN_APP_BROWSER_MARKERS.some((marker) => userAgent.includes(marker))) {
    return true
  }

  if (ANDROID_WEBVIEW_PATTERN.test(userAgent)) {
    return true
  }

  if (IOS_IN_APP_BROWSER_PATTERN.test(userAgent)) {
    return true
  }

  return false
}

let timeout: NodeJS.Timeout

export const useDebounce = (delay = 300) => {
  return {
    debounce: (callback: () => void) => {
      if (timeout) clearTimeout(timeout)
      timeout = setTimeout(callback, delay)
    },
  }
}
